import axiosPrivate from "@services/axiosPrivate"
import { ORDER_INITIATE_URL } from "src/constants"

export const initiateOrder = (data) => {
  return axiosPrivate.post(ORDER_INITIATE_URL, data, {
    withCredentials: true,
  })
}
